/* eslint-disable @typescript-eslint/naming-convention -- MUI naming */

import { type User } from "@entities";
import {
  Button,
  Stack,
  Typography,
} from "@mui/material";
import { type Dispatch, type SetStateAction, type FC } from "react";
import { useRequest } from "../../contexts/RequestProvider";
import FormProvider, { useForm } from "../../helpers/forms/FormProvider";
import { provide } from "../../helpers/wrap-and-provide";
import { FormTextField } from "../form-components/form-text-field/FormTextField";
import PhoneNumberCell from "../../pages/tables/PhoneNumberCell";

interface RequesterDetailsProps {
  requesterDetails?: User | null;
  setIsAddAidRelated: Dispatch<SetStateAction<boolean>>;
}

const RequesterDetails: FC<RequesterDetailsProps> = ({
  requesterDetails,
  setIsAddAidRelated,
}) => {
  const { setFieldValue } = useForm<Partial<User>>();

  const hasRequesterDetails =
    !!requesterDetails?.name?.trim() || !!requesterDetails?.phoneNumber;

  return (
    <>
      {hasRequesterDetails ? (
        <Stack width="90%" spacing={0.5}>
          <Typography
            fontSize="large"
            fontWeight={700}
            color="primary"
            className="field-label"
          >
            פרטי מבקש הסיוע
          </Typography>
          <Stack direction="row" gap="1rem" alignItems="flex-end" flexWrap="wrap">
            <FormTextField
              InputProps={{
                sx: { "&.field": { height: "2rem", borderRadius: "0.6rem" } },
              }}
              value={requesterDetails?.name}
              label="שם מלא"
              name="requesterName"
              disabled={true}
            />
            <Stack spacing={0.25}>
              <Typography variant="caption" color="text.secondary">
                מספר טלפון
              </Typography>
              {requesterDetails?.phoneNumber ? (
                <PhoneNumberCell phoneNumber={requesterDetails.phoneNumber} />
              ) : (
                <Typography variant="body2">-</Typography>
              )}
            </Stack>
          </Stack>
        </Stack>
      ) : (
        <Stack
          width="100%"
          spacing={0.5}
          flexDirection="row"
          alignItems="center"
          gap="3rem"
        >
          <Button
            variant="outlined"
            sx={{
              gap: "0.4rem",
              borderRadius: "0.6rem",
              height: "2rem",
              marginTop: "1.8rem",
              alignItems: "center",
              borderColor: "rgba(0, 0, 0, 0.23)",
            }}
            onClick={() => {
              setIsAddAidRelated(true);
              setFieldValue("phoneNumber", "");
            }}
          >
            הוספת מבקש סיוע
          </Button>
        </Stack>
      )}
    </>
  );
};

export default provide([
  FormProvider,
  { initialValues: {}, onSubmit: () => { } },
])(RequesterDetails);
/* eslint-enable @typescript-eslint/naming-convention -- MUI naming */
